
// make imports dynamic
import './legacy/jquery-global.js';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { initJourneyAnalytics } from './journey-analytics.js';
import { emitReferral as emitOofReferral } from './rfs-oof-modal.js';

// Journey Analytics: no-op unless Blade rendered #journey-analytics-config. Started before the
// legacy chain below so page_view (and the cookie handshake) do not wait for it.
const journeyAnalytics = initJourneyAnalytics(window);

// RFS OOF modal experiments: one-shot referral hand-over (referral_url + modal_type) on the page a modal CTA led to.
// No-op unless the short-lived upc_oof_ref cookie of a CTA click exists and is valid for this page. The same validated
// payload goes to the dataLayer and to Journey Analytics (o2_oof_referral).
emitOofReferral(window, journeyAnalytics);

// Checkout Exit Recovery popup (test mode): loaded ONLY when the checkout layout rendered #checkout-exit-recovery,
// which the server does only for an eligible visitor (App\Services\CheckoutExitRecovery\Eligibility).
if (document.getElementById('checkout-exit-recovery')) {
    import('./checkout-exit-recovery.js').then(({ initCheckoutExitRecovery }) => initCheckoutExitRecovery(window, journeyAnalytics)).catch(() => {});
}

// Behavior Analytics (click & scroll): loaded ONLY when the server rendered #behavior-analytics-config, i.e. never with
// the default configuration. The loader then waits for Cookiebot Statistics consent before it loads the collector chunk.
if (document.getElementById('behavior-analytics-config')) {
    import('./behavior/loader.js').then(({ initBehaviorAnalytics }) => initBehaviorAnalytics(window)).catch(() => {});
}

(async () => {
    //await import('./jquery-ui.min.js');
    //await import('jquery-validation/dist/jquery.validate.js');
    //await import('jquery-validation/dist/additional-methods.js');
    //await import('jquery-mask-plugin/dist/jquery.mask.js');

    await import('jquery-validation/dist/jquery.validate.js');
    await import('jquery-validation/dist/additional-methods.js');
    await import('./legacy/swiper-global.js');
    await import('./legacy/datatables-global.js');

    await import('./jquery.min.js');
    await import('./jquery-ui.min.js');
    await import('./jquery.validate.min.js');
    await import('./jquery.validate.additional-methods.min.js');
    await import('./jquery.mask.js');
    await import('./swiper.min.js');
    await import('./DataTables/datatables.min.js');
    await import('./jquery.countdown.min.js');
    await import('./sticky.js');
    await import('./jquery.modal.min.js');
    await import('./protip.min.js');
    await import('./jquery.lazy.min.js');
    await import('./jquery.datetimepicker.js');
    await import('./anim-event.min.js');
    await import('./leader-line.min.js');
    await import('./amelia.js');
    await import('./app.js');

    // jquery.modal attaches to the jQuery 3 instance from jquery.min.js (it replaces the npm
    // jQuery on window); modal_open / modal_close bind to that same instance.
    journeyAnalytics.attachJQuery(window.jQuery);
})();
/*
import './legacy/jquery-global.js';
import './jquery-ui.min.js';
import './jquery.validate.min.js';
import './jquery.validate.additional-methods.min.js';
import './jquery.mask.js';
import './swiper.min.js';
import './DataTables/datatables.min.js';
import './jquery.countdown.min.js';
import './sticky.js';
import './jquery.modal.min.js';
import './protip.min.js';
import './jquery.lazy.min.js';
import './jquery.datetimepicker.js';
import './anim-event.min.js';
import './leader-line.min.js';
import './amelia.js';
import './app.js';
*/
